import { Record } from 'immutable';

export const ProductLevelCommissionRecord = Record({
  stylistID: undefined,
  stylist: undefined,
  commissionValue: 0
});
